/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import imagesLoaded from 'imagesloaded';
import './plugins/jquery.mobile.custom.js';
import Swiper from 'swiper/bundle';
import LazyLoad from 'vanilla-lazyload';
import GLightbox from 'glightbox';
// import videojs from 'video.js';
// import '@devmobiliza/videojs-vimeo/dist/videojs-vimeo.esm';

$(document).ready(() => {

var isIOS = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
console.log('ios: ' + isIOS);

// Touch Class
/*
if (!("ontouchstart" in document.documentElement) || !isIOS) {
  $('html').addClass('no-touch');
} else {
  $('html').addClass('touch');
}
*/
if (!isIOS) {
  $('html').addClass('noios');
} else {
  $('html').addClass('ios');
}

// navbar handling
// https://gist.github.com/sarvar/79ecdc7c97bbdc9d6debf94fc19e57cb
var stickyToggle = function(sticky, stickyWrapper, scrollElement) {
  var stickyHeight = sticky.outerHeight();
  var stickyTop = stickyWrapper.offset().top;
  if (scrollElement.scrollTop() >= stickyTop){
    stickyWrapper.height(stickyHeight);
    sticky.addClass("is-sticky");
  }
  else{
    sticky.removeClass("is-sticky");
    stickyWrapper.height('auto');
  }
};

// Find all data-toggle="sticky-onscroll" elements
$('[data-toggle="sticky-onscroll"]').each(function() {
  var sticky = $(this);
  var stickyWrapper = $('<div>').addClass('sticky-wrapper'); // insert hidden element to maintain actual top offset on page
  sticky.before(stickyWrapper);
  sticky.addClass('sticky');

  // Scroll & resize events
  $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function() {
    stickyToggle(sticky, stickyWrapper, $(this));
  });

  // On page load
  stickyToggle(sticky, stickyWrapper, $(window));
});

$('.navbar-hamburger').click(() => {
  $('#menu').addClass('showMenu');
});

// SOURCE

// handling of intro overlay
$('html').addClass('noScrollbars');

function showPage(){
  $('.balken').removeClass('.balken');
  $('.balken').hide();
  $('html').addClass('showPage');
}

function showScrollbars() {
  $('.balken').removeClass('.balken');
  $('.balken').hide();
  $('html').removeClass('noScrollbars');
  $('.pageOverlay').hide();
}

function showMe(){
  $('html').addClass('imagesLoaded');
}

setTimeout(showMe, 0);

$('.pageOverlay').click(() => {
  $('html').addClass('showPage');
  setTimeout(showScrollbars, 1000);
  console.log('x1');
});

$('html').bind('mousewheel DOMMouseScroll', function (e) {
  var delta = (e.originalEvent.wheelDelta || -e.originalEvent.detail);
  if (delta < 0) {
    $('html').addClass('showPage');
    setTimeout(showPage, 0);
    setTimeout(showScrollbars, 1000);
  }
});

$(".pageOverlay").scrollstart(function() {
  $('html').addClass('showPage');
  setTimeout(showScrollbars, 1000);
  console.log('x2');
});

// Umschaltung
$( ".menu-item" ).each(function() {
  $(this).on("click", function(){
    if ((window.location.pathname != '/') && document.referrer.indexOf('muellersbureau.at') >= 0 && ($(this).attr('data-target') == '.muellersbureau-col-projekte')) {
      event.preventDefault();
      history.go(-1);
    }
    console.log('click 1');
    if ((window.location.pathname != '/datenschutzerklaerung/' ) && (window.location.pathname != '/en/data-protection/')) {
      console.log('click 2');
      $('.menu-item').removeClass('is-active');
      $(this).addClass('is-active');
      $('.col-swiper').removeClass('is-active');
      var supermuellersbureau = $(this).attr('data-target');
      $(supermuellersbureau).addClass('is-active');
      // console.log(supermuellersbureau + ' <' );
      if (supermuellersbureau == '.muellersbureau-col-bureau') {
        var scrolltarget = $(this).attr('data-swiper-position');
        swiper[0].slideTo(scrolltarget, 0);
      }
      var copypaste = $('.col-swiper.is-active .swiper-wrapper').html();
      $('.houdini').html(copypaste);
      lazyLoadProjekte.update();
      lazyLoadMuellersbureau.update();
      $(window).scrollTop(0);
      var heightOffset = $('.sticky-wrapper').height();
      if ($(this).attr('id') == 'btn-team') {
        $('html, body').animate({
          scrollTop: ($(".houdini #team").offset().top - heightOffset)
        }, 10);
      }
      if ($(this).attr('id') == 'btn-awards') {
        $('html, body').animate({
          scrollTop: ($(".houdini #awards").offset().top - heightOffset)
        }, 10);
      }
      if ($(this).attr('id') == 'btn-imprint') {
        $('html, body').animate({
          scrollTop: ($(".houdini #imprint").offset().top - heightOffset)
        }, 10);
      }
      if ($(this).attr('id') == 'btn-contact') {
        $('html, body').animate({
          scrollTop: ($(".houdini #contact").offset().top - heightOffset)
        }, 10);
      }
      if ($(this).attr('id') == 'btn-kontakt') {
        $('html, body').animate({
          scrollTop: ($(".houdini #kontakt").offset().top - heightOffset)
        }, 10);
      }
    }
    $('.nolightbox').click(function(){
      console.log('iOS Video Start');
      var targetVideo = $(this).attr('data-target');
      var videoPlayer = document.getElementById(targetVideo);
      videoPlayer.preload = "auto";
      videoPlayer.addEventListener('ended', onVideoEnded, false);
      videoPlayer.play();
    });
    $('#menu').removeClass('showMenu');
  });
});

$( "#menu a" ).each(function() {
  $(this).on("click", function(){
    $('#menu').removeClass('showMenu');
  });
});

$('#menu').click(() => {
  $('#menu').removeClass('showMenu');
});

$('.backtothefuture').click(() => {
  if ((window.location.pathname != '/') && document.referrer.indexOf('muellersbureau.com') >= 0) {
    event.preventDefault();
    history.go(-1);
  }
});

// Viewport Höhe
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  lazyLoadMuellersbureau.update();
  lazyLoadProjekte.update();
});

  /* eslint-disable */
  var lightbox = GLightbox({
    plyr: {
      config: {
        ratio: '16:9', // or '4:3'
        muted: false,

        fullscreen:	{ enabled: true, fallback: true, iosNative: true },
        volume: 1,
        hideControls: true,
      }
    },
    selector: '.glightbox',
    videosWidth: '100%',
    title: false,
    touchNavigation: false,
    loop: false,
    autoplayVideos: true
  });

  var swiper = new Swiper('.scroll-container', {
    direction: 'vertical',
    slidesPerView: 'auto',
    freeMode: true,
    freeModeMomentum: true,
    freeModeMomentumBounce: false,
    mousewheel: true,
    allowSlidePrev: true,
		allowSlideNext: true,
    observer: true,
    observeSlideChildren: true,
    observeParents: true,
  });

  // TARGET

  // muellersbureau
  var hash = window.location.hash;
  if (hash.indexOf('muellersbureau') > 0) {
    console.log('#muellersbureau');
    $('.pageOverlay').hide();
    $(window).scrollTop(0);
    var copypaste = $('.muellersbureau-col-muellersbureau .swiper-wrapper').html();
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-muellersbureau').addClass('is-active');
  } else if (hash.indexOf('bureau') > 0) {
    console.log('#bureau');
    $('.pageOverlay').hide();
    $(window).scrollTop(0);
    var copypaste = $('.muellersbureau-col-bureau .swiper-wrapper').html();
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-bureau').addClass('is-active');
    swiper[0].slideTo(0, 0);
  } else if (hash.indexOf('projekte') > 0) {
    console.log('projekte');
    $('.pageOverlay').hide();
    var copypaste = $('.muellersbureau-col-projekte .swiper-wrapper').html();
    console.log(copypaste);
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-projekte').addClass('is-active');

    $('.nolightbox').click(function(){
      console.log('iOS Video Start');
      var targetVideo = $(this).attr('data-target');
      var videoPlayer = document.getElementById(targetVideo);
      videoPlayer.addEventListener('ended', onVideoEnded, false);
      videoPlayer.play();
    });
  } else if (hash.indexOf('projects') > 0) {
    console.log('projects');
    $('.pageOverlay').hide();
    var copypaste = $('.muellersbureau-col-projects .swiper-wrapper').html();
    console.log(copypaste);
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-projects').addClass('is-active');
  } else if (hash.indexOf('team') > 0) {
    console.log('#team');
    $('.pageOverlay').hide();
    $(window).scrollTop(0);
    var copypaste = $('.muellersbureau-col-bureau .swiper-wrapper').html();
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-bureau').addClass('is-active');
    swiper[0].slideTo(1, 0);
  } else if (hash.indexOf('awards') > 0) {
    console.log('#awards');
    $('.pageOverlay').hide();
    $(window).scrollTop(0);
    var copypaste = $('.muellersbureau-col-bureau .swiper-wrapper').html();
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-bureau').addClass('is-active');
    swiper[0].slideTo(2, 0);
  } else if (hash.indexOf('imprint') > 0) {
    console.log('#imprint');
    $('.pageOverlay').hide();
    $(window).scrollTop(0);
    var copypaste = $('.muellersbureau-col-bureau .swiper-wrapper').html();
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-bureau').addClass('is-active');
    swiper[0].slideTo(3, 0);
  } else if (hash.indexOf('kontakt') > 0) {
    console.log('#kontakt');
    $('.pageOverlay').hide();
    $(window).scrollTop(0);
    var copypaste = $('.muellersbureau-col-bureau .swiper-wrapper').html();
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-bureau').addClass('is-active');
    swiper[0].slideTo(4, 0);
  } else if (hash.indexOf('contact') > 0) {
    console.log('#contact');
    $('.pageOverlay').hide();
    $(window).scrollTop(0);
    var copypaste = $('.muellersbureau-col-contact .swiper-wrapper').html();
    $('html').addClass('noScrollbars');
    $('html').addClass('imagesLoaded');
    $('html').addClass('showPage');
    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-contact').addClass('is-active');
    swiper[0].slideTo(4, 0);
  } else {
    $('html .datenschutzerklaerung').parent().addClass('showPage').removeClass('noScrollbars').addClass('imagesLoaded');
    $('html .data-protection').parent().addClass('showPage').removeClass('noScrollbars').addClass('imagesLoaded');
    var copypaste = $('.muellersbureau-col-muellersbureau .swiper-wrapper').html();
    if (!copypaste) {
      var copypaste = $('.muellersbureau-col-datenschutz .swiper-wrapper').html();
    }
    console.log('no more!');

    $('.col-swiper').removeClass('is-active');
    $('.muellersbureau-col-muellersbureau').addClass('is-active');
  }
  if (window.location.pathname != '/' && window.location.pathname != '/en/' && window.location.pathname != '/datenschutzerklaerung' && window.location.pathname != '/datenschutzerklaerung/' && window.location.pathname != '/en/data-protection/' && window.location.pathname != '/en/data-protection') {
    var copypaste = $('.col-images .swiper-wrapper').html() +  $('.col-images-small .swiper-wrapper').html() + $('.col-description .swiper-wrapper').html();
    $('.itsmagic .swiper-wrapper').html( $('.col-images .swiper-wrapper').html() +  $('.col-images-small .swiper-wrapper').html() );
  }
  $('.houdini').html(copypaste);
  $(window).scrollTop(0);
  var heightOffset = $('.sticky-wrapper').height();
  if (hash.indexOf('team') > 0) {
    $('html, body').animate({
      scrollTop: ($(".houdini #team").offset().top - heightOffset + 40)
    }, 10);
  }
  if (hash.indexOf('awards') > 0) {
    $('html, body').animate({
      scrollTop: ($(".houdini #awards").offset().top - heightOffset + 40)
    }, 10);
  }
  if (hash.indexOf('imprint') > 0) {
    $('html, body').animate({
      scrollTop: ($(".houdini #imprint").offset().top - heightOffset + 40)
    }, 10);
  }
  if (hash.indexOf('contact') > 0) {
    $('html, body').animate({
      scrollTop: ($(".houdini #contact").offset().top - heightOffset + 40)
    }, 10);
  }
  if (hash.indexOf('kontakt') > 0) {
    $('html, body').animate({
      scrollTop: ($(".houdini #kontakt").offset().top - heightOffset + 40)
    }, 10);
  }


  $('.mb').click(() => {
    console.log(swiper);
    swiper[0].slideTo(0, 0);
  });

  /* swiper videos */
  var sliderVideos = $(".swiper-slide video");
  // sliderVideos.removeAttr('autoplay');

  var introSwiper = new Swiper ('#intro-swiper', {
    direction: 'horizontal',
    loop: true,
    mousewheel: false,
    // keyboard: true,
    spaceBetween: 0,
    centeredSlides: true,
    speed: 500,
    effect: 'slide',
    // noSwiping: true,
    // noSwipingClass: 'swiper-no-swiping',
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
    on: {
      init: function () {
        /* do something */
        var currentFortschritt =  $("[data-swiper-slide-index=" + this.realIndex + "]").find(".fortschritt");
        currentFortschritt.addClass('is-active');
      },
    }
  })

  /* LazyLoad */
  // https://github.com/verlok/vanilla-lazyload#lazy-video
  var lazyLoadIntro = new LazyLoad({
    elements_selector: ".lazy-intro",
    callback_loaded: function(el) {
      // var currentVideo =  $("[data-swiper-slide-index=" + 0 + "]").find("video");
      // currentVideo.autoplay = true;
      sliderVideos[0].play();
    },
  });

  var lazyLoadMuellersbureau = new LazyLoad({
    elements_selector: ".lazy-muellersbureau",
    // container: document.querySelector(".muellersbureau-col-muellersbureau .swiper-container"),
    callback_loaded: function(el) {
      swiper[1].update();
      // $('.houdini').update();
    },
  });

  var lazyLoadProjekte = new LazyLoad({
    elements_selector: ".lazy-projekt",
    // container: document.querySelector(".swiper-projekte"),
    callback_loaded: function(el) {
      // $('.glightbox').addClass('enabled');
      swiper[1].update();
      if (swiper[2]) {
        swiper[2].update();
      }
      // $('.houdini').update();
    },
  });

  /* swiper events */
  introSwiper.on("slideChange", function() {
    var prevFortschritt =  $("[data-swiper-slide-index=" + this.previousIndex + "]").find(".fortschritt");
    prevFortschritt.removeClass('is-active');
    var currentVideo =  $("[data-swiper-slide-index=" + this.realIndex + "]").find("video");
    if(sliderVideos[this.realIndex].paused) {
      sliderVideos[this.realIndex].play();
    };
  });

  introSwiper.on("slideChangeTransitionEnd", function() {
    var prevVideo =  $("[data-swiper-slide-index=" + this.previousIndex + "]").find("video");
    var currentFortschritt =  $("[data-swiper-slide-index=" + this.realIndex + "]").find(".fortschritt");
    currentFortschritt.addClass('is-active');
  });

  // Test Video
//  function onVideoEnded(event) {
//    console.log('iOS Video End');
//    this.webkitExitFullscreen();
//  }

//  $('.nolightbox').click(function(){
//    console.log('iOS Video Start');
//    var targetVideo = $(this).attr('data-target');
//    var videoPlayer = document.getElementById(targetVideo);
//    videoPlayer.addEventListener('ended', onVideoEnded, false);
//    videoPlayer.play();
//  });

  if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
    $(document).on('click', '.nolightbox', function() {
      var targetVideo = $(this).attr('data-target');
      var videoPlayer = document.getElementById(targetVideo);

      function onVideoEnded(event) {
        console.log('iOS Video End');
        this.webkitExitFullscreen();
      }

      function onVideoPlay(event) {
        console.log('iOS Video Play');
        // videoPlayer.style = 'position: absolute; z-index: 3; height: 100%; background: #000; opacity: 0; transition: 150ms;';
        videoPlayer.style = 'opacity: 0; transition: 150ms; display: none !important;'
      	requestAnimationFrame(function() {
          // videoPlayer.style = 'position: absolute; z-index:3; height: 100%; background: #000; opacity: 1; transition: 150ms;';
          videoPlayer.style = 'opacity: 0; transition: 150ms; display: block !important;'
      	})
      }

      function onVideoPause(event) {
        console.log('iOS Video Pause');
        // videoPlayer.style = 'display: none !important; background: #000; opacity: 0;';
        videoPlayer.style = 'opacity: 0; display: none !important;';
      }

      console.log('iOS Video Start');
      videoPlayer.addEventListener('ended', onVideoEnded, false);
      videoPlayer.addEventListener('play', onVideoPlay, false);
      videoPlayer.addEventListener('pause', onVideoPause, false);
      videoPlayer.play();
    });
  } else {
    function onVideoEnded(event) {
      console.log('iOS Video End');
      this.webkitExitFullscreen();
    }

    $(document).on('click', '.nolightbox', function(){
      console.log('iOS Video Start');
      var targetVideo = $(this).attr('data-target');
      var videoPlayer = document.getElementById(targetVideo);
      videoPlayer.addEventListener('ended', onVideoEnded, false);
      videoPlayer.play();
    });
  }
  /* eslint-enable */
});
